module.exports = __webpack_public_path__ + "static/media/part_of_larv.00bdd063.jpg";